export default __webpack_public_path__ + "static/media/documentMan.5c301126.svg";